export function fetchActiveAnnouncements(apiUrl, accessToken) {

  return fetch(`${apiUrl}/v1/announcements/active`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}